<template>
  <div class="book-price-message">
    <!-- HEAD PAGE -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100 head-page">
        <div class="md-layout-item md-size-80" style="font-family: Kanit;">
          กล่องข้อความ
        </div>
        <div
          class="md-layout-item md-size-20 message-bog"
          style="display: flex;"
        >
          <div style="width: 83%;">
            กล่องข้อความ
            <md-icon>mail_outline</md-icon>
            <span class="custom-chip message">{{ formatNumber(0, 0) }}</span>
          </div>
          <div
            style="cursor: pointer; width: 17%;"
            title="MANAGE BOOK PRICE"
            @click="onClickReOrder()"
          >
            <md-icon>reorder</md-icon>
          </div>
        </div>
      </div>
    </div>

    <!-- ACTION -->
    <div class="md-layout">
      <div
        class="md-layout-item md-size-100 block-action"
        style="padding-top: 0px;"
      >
        <div class="input-search">
          <md-field class="md-search-box">
            <md-icon>search</md-icon>
            <md-input
              type="text"
              placeholder="Search with..."
              v-model="valueSearch"
            ></md-input>
          </md-field>
        </div>
      </div>
    </div>

    <!-- TABLE -->
    <div class="md-layout-item md-size-100 table-message">
      <!-- HEAD -->
      <div class="divHeadList">
        <div style="width: 13%;">Title</div>
        <div style="width: 69%;">Description</div>
        <div style="width: 18%;" class="-text-center">Last Update</div>
      </div>

      <!-- BODY -->
      <div class="divBodyList">
        <div
          v-show="tableMessage.length === 0"
          :class="'row-bg-gray'"
          style="display: block; text-align: center; font-size: 14px;"
        >
          No data in table.
        </div>

        <div
          :class="'row-bg-gray'"
          v-for="(item, rIndex) in tableMessage"
          :key="rIndex"
          @click="onSelectRow(item)"
          style="cursor: pointer;"
        >
          <div style="width: 13%; font-weight: bold;">{{ item.title }}</div>
          <div
            style="width: 69%;"
            class="nowrap-title -font-kanit"
            :title="item.desc"
          >
            {{ item.desc }}
          </div>
          <div style="width: 18%;" class="-text-center">{{ item.u_date }}</div>
        </div>
      </div>

      <!-- FOOTER -->
      <div class="footer-table">
        number of lines in page ({{ tableMessage.length }})
      </div>
    </div>

    <dialog-change-price
      :show="showDialogChangePrice"
      @cancel="onClickCancel()"
      @notchange="onClickNotChange()"
      @confirm="onClickConfirm()"
    ></dialog-change-price>
  </div>
</template>

<script>
import GlobalService from "@/services/global_function";
import BookpriceService from "@/services/bookprice";
import DialogChangePrice from "./dialog-change-price";

export default {
  name: "book-price-message",

  components: {
    DialogChangePrice
  },

  data() {
    return {
      valueSearch: "",
      tableMessage: [],
      showDialogChangePrice: false
    };
  },

  created() {
    BookpriceService.makeDataTableMessage().then(response => {
      this.tableMessage = response;
    });
  },

  methods: {
    formatNumber(value, dicimal) {
      return GlobalService.formatNumber(value, dicimal);
    },
    onSelectRow() {
      this.showDialogChangePrice = true;
    },
    onClickCancel() {
      this.showDialogChangePrice = false;
    },
    onClickNotChange() {
      this.showDialogChangePrice = false;
    },
    onClickConfirm() {
      this.showDialogChangePrice = false;
    },
    onClickReOrder() {
      this.$router.push("/overview/book-price");
    }
  }
};
</script>

<style lang="scss">
.book-price-message {
  .custom-chip.message {
    right: 3.7%;
  }

  .table-message {
    .divBodyList {
      height: calc(100vmin - 213px);
    }
  }
}
</style>